import React from 'react'
import { TowingRecordServiceType } from '../../common/types'
import { FormSubGroup, FormSubGroupHeading, ImageWrapper, Section, SectionColumn } from '../../components/layout'
import { DateInput, NumberInput, SelectInput, TextAreaInput, TextInput } from '../../components/layout/form/input'
import { ALFormSubGroupHeader, ALFormSubGroupWrapper } from '../ALOrderSubForm'
import autoliitto from '../../images/autoliitto.png'
import { AlArcCodesForm } from '../AlArcCodesForm'

interface ALSubFormProps {
  getValue: (value: string) => string
  setValue: (field: string, value: string) => void
  serviceTypeOptions: object[]
  serviceType?: TowingRecordServiceType
}

export const ALSubForm: React.FC<ALSubFormProps> = ({ serviceTypeOptions, getValue, setValue }) => {
  return (
    <ALFormSubGroupWrapper>
      <ALFormSubGroupHeader>
        <FormSubGroupHeading>
          <ImageWrapper>
            <img src={autoliitto} alt="AL" width={`95px`} />
          </ImageWrapper>
        </FormSubGroupHeading>
      </ALFormSubGroupHeader>
      <FormSubGroup>
        <Section>
          <SectionColumn>
            <DateInput label="Päivämäärä" name="jobDetails.towingDate" />
          </SectionColumn>
          <SectionColumn>
            <NumberInput label="Mittarilukema, km" name="automobileAndTouringClubFinland.vehicleMileage" decimals={0} />
          </SectionColumn>
          <SectionColumn>
            <TextInput label="Tilauksen viite" name="automobileAndTouringClubFinland.caseNumber" disabled />
          </SectionColumn>
          <SectionColumn>
            <TextInput label="Laskutus" name="automobileAndTouringClubFinland.billingInfo" disabled />
          </SectionColumn>
          <SectionColumn>
            <NumberInput label="Henkilömäärä" name="automobileAndTouringClubFinland.personCount" decimals={0} />
          </SectionColumn>
          <SectionColumn>
            <TextInput label="Palvelukanava" name="automobileAndTouringClubFinland.serviceChannel" disabled />
          </SectionColumn>

          {/*<SectionColumn>
            {serviceType === TowingRecordServiceType.TOWING && (
              <NumberInput label="Laskutettavat kilometrit" name="automobileAndTouringClubFinland.distanceTowed" />
            )}
          </SectionColumn>*/}
        </Section>
        <Section>
          <SectionColumn>
            <SelectInput label="Työn tyyppi" name="jobDetails.serviceType" options={serviceTypeOptions} />
          </SectionColumn>
          <AlArcCodesForm getValue={getValue} setValue={setValue} />
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <TextAreaInput label="Työselvitys Autoliitolle" name="jobDetails.additionalInfo" />
          </SectionColumn>
          <SectionColumn>
            <TextAreaInput label="Muistiinpanot (sisäiseen käyttöön)" name="jobDetails.notes" />
          </SectionColumn>

          {/*<SectionColumn>
            <TextAreaInput
              label="Autoliiton tilannearvio"
              name="automobileAndTouringClubFinland.situationDescription"
              disabled
            />
          </SectionColumn>*/}
        </Section>
      </FormSubGroup>
    </ALFormSubGroupWrapper>
  )
}
